import i18next from "i18next";
import { eng } from './en'
import { esp } from './es'
import { ita } from './it'

import config from '../config/defaultInvoiceSettings'
import { useContext } from "react";
import { UserContext } from '../context/UserContext';


console.log("this languaje ===>  ");
const idioma = config.languaje;




i18next.init({
    interpolation: {
        escapeValue: false
    },
    lng: config.languaje,
    resources: {
        en: {
            translation: eng,
        },
        es: {
            translation: esp,

        },
        it: {
            translation: ita,
        }
    }
}

)

export default i18next;